
import { supabase } from "@/integrations/supabase/client";
import { WalletData } from "@/models/wallet";

export class WalletService {
  /**
   * Get wallet data for a specific user
   */
  static async getWallet(userId: string): Promise<WalletData | null> {
    try {
      // Check if there's a wallet table in the database
      const { data, error } = await supabase
        .from("wallets")
        .select("*")
        .eq("user_id", userId)
        .single();

      if (error) {
        console.error("Error fetching wallet:", error);
        
        // If the table doesn't exist or other error, return a mock wallet
        // This is temporary until proper wallet functionality is implemented
        return {
          id: "mock-wallet-id",
          userId: userId,
          balance: 0,
          currency: "USD",
          createdAt: new Date(),
          updatedAt: new Date()
        };
      }

      // Transform the database wallet object to the WalletData model
      return {
        id: data.id,
        userId: data.user_id,
        balance: data.balance || 0,
        currency: data.currency || "USD",
        createdAt: new Date(data.created_at),
        updatedAt: new Date(data.updated_at)
      };
    } catch (error) {
      console.error("Error in getWallet:", error);
      throw error;
    }
  }

  /**
   * Update wallet balance for a user
   */
  static async updateWalletBalance(userId: string, newBalance: number): Promise<WalletData | null> {
    try {
      const { data, error } = await supabase
        .from("wallets")
        .update({ balance: newBalance, updated_at: new Date().toISOString() })
        .eq("user_id", userId)
        .select()
        .single();

      if (error) {
        console.error("Error updating wallet balance:", error);
        throw error;
      }

      return {
        id: data.id,
        userId: data.user_id,
        balance: data.balance,
        currency: data.currency,
        createdAt: new Date(data.created_at),
        updatedAt: new Date(data.updated_at)
      };
    } catch (error) {
      console.error("Error in updateWalletBalance:", error);
      throw error;
    }
  }
}
